import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserAuth } from './AuthContext';

function MainHeader() {
  const { logout } = UserAuth();
  const navigate = useNavigate();
  const [waitlistDropdownOpen, setWaitlistDropdownOpen] = useState(false);
  const [absenceDropdownOpen, setAbsenceDropdownOpen] = useState(false);
  const [healthDropdownOpen, setHealthDropdownOpen] = useState(false);
  const [withdrawalDropdownOpen, setWithdrawalDropdownOpen] = useState(false);
  const waitlistDropdownRef = useRef(null);
  const absenceDropdownRef = useRef(null);
  const healthDropdownRef = useRef(null);
  const withdrawalDropdownRef = useRef(null);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/home');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  const toggleWaitlistDropdown = () => {
    setWaitlistDropdownOpen(!waitlistDropdownOpen);
    setAbsenceDropdownOpen(false);
    setHealthDropdownOpen(false);
    setWithdrawalDropdownOpen(false);
  };

  const toggleAbsenceDropdown = () => {
    setAbsenceDropdownOpen(!absenceDropdownOpen);
    setWaitlistDropdownOpen(false);
    setHealthDropdownOpen(false);
    setWithdrawalDropdownOpen(false);
  };

  const toggleHealthDropdown = () => {
    setHealthDropdownOpen(!healthDropdownOpen);
    setWaitlistDropdownOpen(false);
    setAbsenceDropdownOpen(false);
    setWithdrawalDropdownOpen(false);
  };

  const toggleWithdrawalDropdown = () => {
    setWithdrawalDropdownOpen(!withdrawalDropdownOpen);
    setWaitlistDropdownOpen(false);
    setAbsenceDropdownOpen(false);
    setHealthDropdownOpen(false);
  };

  const handleClickOutside = (event) => {
    if (waitlistDropdownRef.current && !waitlistDropdownRef.current.contains(event.target)) {
      setWaitlistDropdownOpen(false);
    }
    if (absenceDropdownRef.current && !absenceDropdownRef.current.contains(event.target)) {
      setAbsenceDropdownOpen(false);
    }
    if (healthDropdownRef.current && !healthDropdownRef.current.contains(event.target)) {
      setHealthDropdownOpen(false);
    }
    if (withdrawalDropdownRef.current && !withdrawalDropdownRef.current.contains(event.target)) {
      setWithdrawalDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="sticky top-0 z-50 border-b border-blue-900/40 bg-gradient-to-r from-blue-950 via-blue-900 to-blue-800 px-4 py-3 shadow-lg backdrop-blur-sm">
      <nav className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-between gap-3">
        <div className="rounded-md bg-white/10 px-3 py-1.5 text-sm font-semibold tracking-wide text-blue-50">
          Teddy&apos;s Ladder
        </div>
        <ul className="flex flex-wrap items-center gap-2 text-white">
          <li
            className="cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition hover:bg-white/10"
            onClick={() => navigate('/home')}
          >
            Home
          </li>
          <li className="relative" ref={waitlistDropdownRef}>
            <button
              className="cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition hover:bg-white/10 focus:outline-none"
              onClick={toggleWaitlistDropdown}
            >
              Waitlist
            </button>
            {waitlistDropdownOpen && (
              <ul className="absolute left-0 mt-2 w-64 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl z-50">
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/waitlist-home');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Waitlist Home
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/waitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Main Waitlist
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/add-new-student');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Add Student
                </li>
                <li className="border-t border-gray-200 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Class Waitlists
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/cubswaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Cubs
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/teddieswaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Teddies
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/koalaswaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Koalas
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/pandaswaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Pandas
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/preschoolwaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Preschool
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/prekwaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Pre-K
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/kindergartenwaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Kindergarten
                </li>
                <li className="border-t border-gray-200 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Status Waitlists
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/startingwaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Starting
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/futureincomingwaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Future / Incoming
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/declinedwaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Declined
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/archivedwaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Archived
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/enrolledwaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Enrolled
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/phasedoutwaitlist');
                    setWaitlistDropdownOpen(false);
                  }}
                >
                  Too Old
                </li>
              </ul>
            )}
          </li>
          <li className="relative" ref={absenceDropdownRef}>
            <button
              className="cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition hover:bg-white/10 focus:outline-none"
              onClick={toggleAbsenceDropdown}
            >
              Absence Tracker
            </button>
            {absenceDropdownOpen && (
              <ul className="absolute left-0 mt-2 w-52 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl z-50">
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/absence-tracker');
                    setAbsenceDropdownOpen(false);
                  }}
                >
                  Absences
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/staff');
                    setAbsenceDropdownOpen(false);
                  }}
                >
                  Staff
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/new-absence');
                    setAbsenceDropdownOpen(false);
                  }}
                >
                  New Absence
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/new-staff');
                    setAbsenceDropdownOpen(false);
                  }}
                >
                  Add Staff
                </li>
              </ul>
            )}
          </li>
          <li className="relative" ref={healthDropdownRef}>
            <button
              className="cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition hover:bg-white/10 focus:outline-none"
              onClick={toggleHealthDropdown}
            >
              Health Trends
            </button>
            {healthDropdownOpen && (
              <ul className="absolute left-0 mt-2 w-52 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl z-50">
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/create-entry');
                    setHealthDropdownOpen(false);
                  }}
                >
                  Create Entry
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/entries-by-class');
                    setHealthDropdownOpen(false);
                  }}
                >
                  Entries by Class
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/student-entries');
                    setHealthDropdownOpen(false);
                  }}
                >
                  Student Entries
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/staff-entries');
                    setHealthDropdownOpen(false);
                  }}
                >
                  Staff Entries
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/health-analytics');
                    setHealthDropdownOpen(false);
                  }}
                >
                  Analytics
                </li>
              </ul>
            )}
          </li>
          <li className="relative" ref={withdrawalDropdownRef}>
            <button
              className="cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition hover:bg-white/10 focus:outline-none"
              onClick={toggleWithdrawalDropdown}
            >
              Student Withdrawals
            </button>
            {withdrawalDropdownOpen && (
              <ul className="absolute left-0 mt-2 w-56 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl z-50">
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/create-new-withdrawal');
                    setWithdrawalDropdownOpen(false);
                  }}
                >
                  Create Withdrawal
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/create-new-student');
                    setWithdrawalDropdownOpen(false);
                  }}
                >
                  Create New Student
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/student-withdrawals');
                    setWithdrawalDropdownOpen(false);
                  }}
                >
                  Student Withdrawals
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/new-students');
                    setWithdrawalDropdownOpen(false);
                  }}
                >
                  New Students
                </li>
                <li
                  className="cursor-pointer px-4 py-2 text-sm text-black hover:bg-gray-100"
                  onClick={() => {
                    navigate('/withdrawal-analytics');
                    setWithdrawalDropdownOpen(false);
                  }}
                >
                  Analytics
                </li>
              </ul>
            )}
          </li>
          <li className="flex items-center">
            <button
              className="rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow transition hover:bg-red-600"
              onClick={handleLogout}
            >
              Log out
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default MainHeader;
